import { maxPrinterCount } from './constants'
import Header from './parts/Header'
import PrinterList from './parts/PrinterList'
import { PrinterActions } from './types'
import { Layout } from '@/features/layout/types'
import { ConnectionSupport } from '@/features/print/connectionSupport'
import { Printer } from '@/features/print/types'
import ScrollWrapper from '@/features/settings/components/ScrollWrapper'
import { FC } from 'react'
import { StyleSheet } from 'react-native'

type PrintManagementProps = {
    layout: Layout
    printers: Printer[]
    onAddPrinter: () => void
} & PrinterActions

const PrintManagement: FC<PrintManagementProps> = ({
    layout,
    printers,
    onAddPrinter,
    onEditPrinter,
    onDeletePrinter,
}) => {
    const addButtonDisabled =
        printers.length >= maxPrinterCount ||
        ConnectionSupport.getSupportedConnectionTypes().length === 0

    return (
        <ScrollWrapper contentContainerStyle={styles.container}>
            <Header
                layout={layout}
                onAddPrinter={onAddPrinter}
                addButtonDisabled={addButtonDisabled}
            />
            <PrinterList
                printers={printers}
                onEditPrinter={onEditPrinter}
                onDeletePrinter={onDeletePrinter}
            />
        </ScrollWrapper>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingTop: 80,
        alignItems: 'center',
        gap: 12,
    },
})

export default PrintManagement
